import {
  DeliveryDataAddress,
  PlacesSearch,
} from '@/store/delivery/delivery.types'

import { StateGeoAddress } from '@/types/mapServices'

export const getDefaultDeliveryAddress = (
  place: PlacesSearch | null = null,
): DeliveryDataAddress => {
  return {
    address: {
      place: place || null,
      address: null,
    },
    details: null,
    state: StateGeoAddress.READY,
    coordinates: [0, 0],
  }
}
